import { render } from "./App.vue?vue&type=template&id=4478a54a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4478a54a&lang=scss"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__